<template>
  <div>
    <!-- 顶部 banner 上传/展示 -->
    <div class="banner-upload" :style="{ minHeight: '60px' }">
      <el-tooltip v-if="!value.banner" effect="dark" content="推荐尺寸：390 × 380" placement="top">
        <el-upload
          class="banner-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="onBannerChange"
        >
          <i class="el-icon-plus" />
          <div class="el-upload__text">上传广告图片</div>
        </el-upload>
      </el-tooltip>
      <div v-else class="banner-img">
        <img :src="value.banner" style="width: 100%; height: auto; display: block">
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          circle
          class="delete-btn"
          @click="update({ banner: '' })"
        />
      </div>
    </div>

    <!-- 单个按钮跳转 -->
    <div v-if="ctaBtn" style="display:flex;flex-direction:column;align-items:center;margin-top:22px;">
      <button
        :style="{
          marginTop: '8px',
          background: ctaBtn.color || '#4CC40F',
          border: 'none',
          color: '#fff',
          width: btnWithUnit(ctaBtn.width, '220px'),
          height: btnWithUnit(ctaBtn.height, '48px'),
          borderRadius: btnWithUnit(ctaBtn.radius, '30px'),
          fontSize: '1.15em',
          fontWeight: 'bold',
          padding: 0,
          lineHeight: btnWithUnit(ctaBtn.height, '48px'),
          cursor: 'pointer'
        }"
        disabled
      >
        {{ ctaBtn.text || '按钮' }}
      </button>

      <el-input
        v-model="ctaBtn.text"
        placeholder="按钮文案"
        style="width:220px;margin:12px 0px"
        size="mini"
      />
      <el-input
        v-model="ctaBtn.link"
        placeholder="按钮跳转链接"
        style="width:220px"
        size="mini"
      />
      <div style="display:flex;gap:10px;align-items:center;margin:14px 0 10px 0;">
        <span style="font-size:13px;color:#666;">宽</span>
        <el-input
          v-model="ctaBtn.width"
          size="mini"
          placeholder="如220 或 90%"
          style="width:64px;"
        />
        <span style="font-size:13px;color:#666;">高</span>
        <el-input
          v-model="ctaBtn.height"
          size="mini"
          placeholder="如48"
          style="width:64px;"
        />
        <span style="font-size:13px;color:#666;">圆角</span>
        <el-input
          v-model="ctaBtn.radius"
          size="mini"
          placeholder="如30"
          style="width:64px;"
        />
      </div>
      <div style="margin: 10px 0 16px 0;display:flex;align-items:center;">
        <span style="margin-right:8px;">按钮颜色：</span>
        <el-color-picker
          v-model="ctaBtn.color"
          size="mini"
          style="margin-right:10px;"
          show-alpha
        />
        <el-button
          type="danger"
          plain
          size="mini"
          @click="exitCtaBtnMode"
        >
          取消按钮模式
        </el-button>
      </div>
    </div>

    <!-- 聊天对话区 -->
    <div v-else class="chat-area" :style="{ minHeight: '420px', maxHeight: '420px' }">
      <div
        v-for="(msg, idx) in value.flows"
        :key="idx"
        :class="['chat-item', msg.sender === 'user' ? 'user' : '']"
        :style="{ animationDelay: idx * 0.09 + 's' }"
      >
        <div class="chat-avatar-box">
          <el-upload
            class="avatar-upload"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="(file) => onAvatarChange(file, msg.sender)"
          >
            <img
              class="chat-avatar"
              :class="msg.sender === 'user' ? 'user' : ''"
              :src="msg.sender === 'teacher' ? value.teacherAvatar : value.userAvatar"
            >
            <i class="el-icon-plus avatar-upload-icon" />
          </el-upload>
        </div>
        <div
          class="chat-msg"
          :class="msg.sender === 'user' ? 'user' : ''"
          :style="{
            background:
              msg.sender === 'teacher'
                ? colorConfig.questionColor
                : colorConfig.answerColor,
            color: getTextColor(
              msg.sender === 'teacher'
                ? colorConfig.questionColor
                : colorConfig.answerColor
            )
          }"
        >
          <template v-if="msg.type === 'info'">
            <el-input
              v-model="msg.content"
              placeholder="请输入内容"
              size="mini"
              style="width: 220px; margin-right: 6px"
            />
            <el-button
              icon="el-icon-delete"
              size="mini"
              type="text"
              style="color: #f56c6c"
              @click="removeFlow(idx)"
            />
          </template>
          <template v-else-if="msg.type === 'question'">
            <el-input
              v-model="msg.content"
              placeholder="请输入提问内容"
              size="mini"
              style="width: 200px; margin-right: 6px"
            />
            <el-button
              icon="el-icon-delete"
              size="mini"
              type="text"
              style="color: #f56c6c"
              @click="removeFlow(idx)"
            />
          </template>
          <template v-else-if="msg.type === 'answer'">
            <div v-for="(opt, i) in msg.options" :key="i" style="margin-bottom: 10px;">
              <el-input
                v-model="opt.text"
                size="mini"
                placeholder="请输入回答内容"
                style="width: 180px; margin-right: 6px;"
              />
              <el-button
                size="mini"
                type="primary"
                style="margin-right:6px;"
                @click="openLinkDialog(opt)"
              >
                {{ getOptLinks(opt).length ? `查看跳转(${getOptLinks(opt).length})` : '添加跳转' }}
              </el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
                :disabled="msg.options.length <= 1"
                @click="removeAnswerOption(msg, i)"
              />
              <el-checkbox
                v-model="opt.continueFlow"
                style="margin-left: 8px;"
              >
                继续后续对话
              </el-checkbox>
            </div>
            <div>
              <el-button
                icon="el-icon-plus"
                size="mini"
                type="success"
                circle
                :disabled="msg.options.length >= 4"
                @click="addAnswerOption(msg)"
              />
            </div>
          </template>
        </div>
      </div>
      <div class="add-btn-wrap">
        <el-dropdown @command="addFlow">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
          >
            添加消息
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="question">提问</el-dropdown-item>
            <el-dropdown-item command="info">普通信息</el-dropdown-item>
            <el-dropdown-item command="ctaBtn">链接跳转按钮</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 跳转配置弹窗 -->
    <el-dialog
      title="跳转设置"
      :visible.sync="linkDialogVisible"
      width="420px"
      append-to-body
    >
      <el-form v-if="currentOpt" label-width="80px">
        <el-form-item
          v-for="(item, idx) in currentOpt.linkList"
          :key="`link-${idx}`"
          :label="idx === 0 ? '跳转链接' : ' '"
        >
          <div style="display:flex;align-items:center;gap:8px;">
            <el-input v-model="item.url" placeholder="请输入跳转链接" />
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="mini"
              :disabled="currentOpt.linkList.length <= 1"
              @click="removeLinkItem(idx)"
            />
          </div>
        </el-form-item>
        <el-form-item label=" ">
          <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="addLinkItem">
            新增链接
          </el-button>
        </el-form-item>
        <el-form-item label="结束文案">
          <el-input v-model="currentOpt.bMsg" placeholder="请输入结束文案（可选）" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="linkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveLink">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 配色/关键词等设置 -->
    <div style="margin-top: 12px">
      <div
        style="display: flex; align-items: center; gap: 10px; padding: 12px 0px; font-size: 12px;"
      >
        <div class="flex-box">
          <span>提问聊天框：</span>
          <el-color-picker v-model="colorConfig.questionColor" size="mini" />
        </div>
        <div class="flex-box">
          <span>回答聊天框：</span>
          <el-color-picker v-model="colorConfig.answerColor" size="mini" />
        </div>
        <div class="flex-box">
          <span>选项按钮：</span>
          <el-color-picker v-model="colorConfig.optionBtnColor" size="mini" />
        </div>
        <div class="flex-box">
          <span>关键字：</span>
          <el-color-picker v-model="colorConfig.highlightColor" size="mini" />
        </div>
      </div>
      <el-input
        v-model="colorConfig.highlightKeywords"
        size="medium"
        style="width: 100%; margin-bottom: 14px"
        placeholder="请输入关键字（多个请用逗号分隔）"
      />
      <el-input
        v-model="value.adTitle"
        placeholder="请输入广告标题"
        size="medium"
        style="width: 100%; margin-bottom: 14px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdContentForm',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: { type: Object, required: true },
    colorConfig: { type: Object, required: true }
  },
  data() {
    return {
      bannerUploading: false,
      linkDialogVisible: false,
      currentOpt: null
    }
  },
  computed: {
    ctaBtn: {
      get() {
        return this.value.ctaBtn || null
      },
      set(v) {
        this.update({ ctaBtn: v })
      }
    }
  },
  methods: {
    update(data) {
      this.$emit('input', { ...this.value, ...data })
    },

    btnWithUnit(v, defaultVal) {
      if (!v && v !== 0) return defaultVal
      if (typeof v === 'string' && v.trim().endsWith('%')) return v
      if ((v + '').match(/px$|em$|rem$|vw$|vh$/)) return v
      if (!isNaN(Number(v))) return Number(v) + 'px'
      return defaultVal
    },

    // ✅ 仅本地缓存广告图片，不上传
    onBannerChange(file) {
      const raw = file.raw
      if (!raw) return
      const previewUrl = URL.createObjectURL(raw)
      this.update({
        banner: previewUrl,
        _bannerFile: raw
      })
    },

    // ✅ 仅本地缓存头像文件，不上传
    onAvatarChange(file, sender) {
      const raw = file.raw
      if (!raw) return
      const ext = raw.name.split('.').pop().toLowerCase()
      if (!['jpg', 'jpeg', 'png', 'gif'].includes(ext)) {
        this.$message.error('仅支持 jpg/png/jpeg/gif 格式')
        return
      }
      const previewUrl = URL.createObjectURL(raw)
      if (sender === 'teacher') {
        this.update({
          teacherAvatar: previewUrl,
          _teacherAvatarFile: raw
        })
      } else if (sender === 'user') {
        this.update({
          userAvatar: previewUrl,
          _userAvatarFile: raw
        })
      }
    },

    addFlow(type = 'question') {
      if (type === 'ctaBtn') {
        this.update({
          flows: [],
          teacherAvatar: '',
          userAvatar: '',
          ctaBtn: {
            text: '按钮文案',
            link: '',
            color: '#4CC40F',
            width: '220',
            height: '48',
            radius: '30'
          }
        })
        return
      }
      const flows = [...this.value.flows]
      if (type === 'question') {
        flows.push({ type: 'question', sender: 'teacher', content: '' })
        flows.push({
          type: 'answer',
          sender: 'user',
          options: [{ text: '', link: '', linkList: [{ url: '' }], bMsg: '', continueFlow: true }]
        })
      } else if (type === 'info') {
        flows.push({ type: 'info', sender: 'teacher', content: '' })
      }
      this.update({ flows })
      this.$nextTick(this.scrollToBottom)
    },

    removeFlow(idx) {
      const flows = [...this.value.flows]
      const msg = flows[idx]
      if (
        msg.type === 'question' &&
        flows[idx + 1] &&
        flows[idx + 1].type === 'answer'
      ) {
        flows.splice(idx, 2)
      } else {
        flows.splice(idx, 1)
      }
      this.update({ flows })
    },

    addAnswerOption(msg) {
      if (msg.options.length < 4) msg.options.push({ text: '', link: '', linkList: [{ url: '' }], bMsg: '', continueFlow: true })
    },

    removeAnswerOption(msg, i) {
      if (msg.options.length > 1) {
        msg.options.splice(i, 1)
      }
    },

    scrollToBottom() {
      const area = this.$el.querySelector('.chat-area')
      if (area) area.scrollTop = area.scrollHeight
    },

    getTextColor(bgColor) {
      if (!bgColor) return '#333'
      let c = bgColor.substring(1)
      if (c.length === 3) {
        c = c.split('').map((x) => x + x).join('')
      }
      const rgb = parseInt(c, 16)
      const r = (rgb >> 16) & 0xff
      const g = (rgb >> 8) & 0xff
      const b = rgb & 0xff
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#333' : '#fff'
    },

    exitCtaBtnMode() {
      this.update({
        ctaBtn: null
      })
    },

    openLinkDialog(opt) {
      const links = this.getOptLinks(opt)
      if (!Array.isArray(opt.linkList)) {
        this.$set(opt, 'linkList', links.length ? links.map(url => ({ url })) : [{ url: '' }])
      } else if (!opt.linkList.length) {
        opt.linkList.push({ url: '' })
      }
      this.currentOpt = opt
      this.linkDialogVisible = true
    },

    getOptLinks(opt) {
      if (!opt) return []
      const list = Array.isArray(opt.linkList)
        ? opt.linkList.map(item => (item && item.url ? String(item.url).trim() : '')).filter(Boolean)
        : []
      if (list.length) return list
      return opt.link ? [String(opt.link).trim()].filter(Boolean) : []
    },

    addLinkItem() {
      if (!this.currentOpt) return
      if (!Array.isArray(this.currentOpt.linkList)) {
        this.$set(this.currentOpt, 'linkList', [])
      }
      this.currentOpt.linkList.push({ url: '' })
    },

    removeLinkItem(idx) {
      if (!this.currentOpt || !Array.isArray(this.currentOpt.linkList)) return
      if (this.currentOpt.linkList.length <= 1) return
      this.currentOpt.linkList.splice(idx, 1)
    },

    saveLink() {
      const links = this.getOptLinks(this.currentOpt)
      if (links.length) {
        this.currentOpt.link = links[0]
      } else {
        this.currentOpt.link = ''
        this.currentOpt.bMsg = ''
      }
      this.linkDialogVisible = false
      this.currentOpt = null
    }
  }
}
</script>

<style scoped>
.banner-upload {
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 0;
  position: relative;
}
.banner-uploader {
  width: 100%;
  min-height: 60px;
  background: #f7f7f7;
  border: 2px dashed #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}
.flex-box {
  display: flex;
  align-items: center;
}
.banner-img {
  width: 100%;
  position: relative;
}
.banner-img img {
  width: 100%;
  display: block;
  border-radius: 10px;
}
.delete-btn {
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 2;
}
.chat-area {
  min-height: 420px;
  max-height: 420px;
  background: #f2f2f2;
  overflow-y: auto;
  padding: 25px 0px 0px 0px;
  box-sizing: border-box;
  margin-bottom: 5px;
}
.chat-area::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
}
.chat-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  animation: fadeInUp 0.5s cubic-bezier(0.23, 1.04, 0.51, 0.98) both;
}
.chat-item.user {
  flex-direction: row-reverse;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.chat-avatar-box {
  position: relative;
}
.avatar-upload {
  position: relative;
  display: inline-block;
}
.avatar-upload-icon {
  position: absolute;
  right: 0px;
  top: -5px;
  background: #fff;
  border-radius: 50%;
  padding: 2px;
  font-size: 13px;
  color: #aaa;
  border: 1px solid #eee;
  cursor: pointer;
  display: none;
}
.avatar-upload:hover .avatar-upload-icon {
  display: inline-block;
}
.chat-avatar {
  width: 36px;
  margin: 0px 10px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px #d4e2d5;
  background: #eee;
}
.chat-msg {
  padding: 9px 16px;
  border-radius: 14px 14px 14px 14px;
  font-size: 1.08rem;
  box-shadow: 0 2px 8px #d3e1d561;
  max-width: 76vw;
  word-break: break-all;
  text-align: left;
  position: relative;
}
.chat-msg.user {
  text-align: right;
}
.add-btn-wrap {
  display: flex;
  justify-content: center;
  margin: 10px 0 6px 0;
}
</style>
